<div class="tenant-configuration-component" [checkPermissions]="{ roles: ['admin', 'support', 'sales'], checkParashiftPowers: true }">
  @if (configuration$ | async) {
    <!-- Tabs -->
    <ul style="flex-wrap: nowrap; overflow-x: auto; overflow-y: hidden;" class="scroll-container nav nav-tabs card-tabs">
      @for (tab of tabs | iterateObject; track tab) {
        <li
          class="nav-item"
          [class.active]="currentTab === tab.key"
          [class.fst-italic]="formRefs[tab.key]?.form.dirty && currentTab === tab.key"
          (click)="switchTab(tab.key)"
          ><a class="nav-link" [class.active]="currentTab === tab.key" [class.link-danger]="tab.key === 'danger-zone'"><span>{{ tab.value }}@if (formRefs[tab.key]?.form.dirty && currentTab === tab.key) {
          *
        }</span></a>
      </li>
    }
  </ul>
  <!-- Tabs end -->
  <div class="scroll-container fullpage">
    <div class="row">
      <div class="col content-col">
        @if (currentTab === 'general') {
          <general-form [model]="model$ | async" [tenantId]="tenant_id" [disabled]="disableForm" (saveForm)="saveTenantConfiguration($event)" />
        }
        @if (currentTab === 'danger-zone') {
          <danger-zone-form [model]="model$ | async" [disabled]="disableForm" (saveForm)="saveTenantConfiguration($event)" />
        }
      </div>
    </div>
  </div>
} @else {
  <div class="alert alert-warning" role="alert">
    @if (id === null) {
      <span i18n="@@components.tenant_configuration.no_configuration_found">
        No tenant configuration found.
      </span>
    } @else {
      <ng-container i18="@@common.loading_text">We're loading… please wait.</ng-container>
    }
  </div>
}

</div>
